import React, { ReactNode, useCallback } from 'react';

import Button from 'src/components/design-system/Button';
import SelectCompany from 'src/components/SelectCompany';
import useCompany from 'src/hooks/useCompany';
import useDebounceCallback from 'src/hooks/useDebounceCallback';
import { Company } from 'src/types/Companies';
import { SetState } from 'src/types/generic';

interface IDisableStep {
  disablePrev: boolean;
  disableNext: boolean;
}
interface IProps {
  nextStep: () => void;
  prevStep: () => void;
  disableStep?: IDisableStep;
  GuideMe: ReactNode;
  docCount: number;
  showPreview: boolean;
  setShowPreview: SetState<boolean>;
  nextButtonRef?: React.MutableRefObject<HTMLButtonElement | null>;
  hideBackButton: boolean;
  onCompanyChange: (company: Company) => void;
}
const StepNavBar: React.FC<IProps> = ({
  prevStep,
  nextStep,
  disableStep,
  GuideMe,
  docCount,
  showPreview,
  setShowPreview,
  nextButtonRef,
  hideBackButton,
  onCompanyChange,
}) => {
  const { company } = useCompany();
  const togglePreview = useCallback(() => setShowPreview((prev) => !prev), [setShowPreview]);
  const [debouncedNextStep] = useDebounceCallback(nextStep, 400);

  const handleNextButtonClick = () => {
    debouncedNextStep();
    nextButtonRef?.current?.blur();
  };

  return (
    <nav className="flex flex-wrap items-center  mb-1">
      <div className="w-[400px]">
        <SelectCompany onChange={onCompanyChange} />
      </div>
      <div className="flex flex-grow items-center justify-center flex-row ">
        {company?.companyId && (
          <>
            {hideBackButton && (
              <Button color="secondary" onClick={prevStep} disabled={disableStep?.disablePrev}>
                Back
              </Button>
            )}
            <Button
              color="primary"
              onClick={debouncedNextStep}
              onKeyDown={handleNextButtonClick}
              disabled={disableStep?.disableNext}
              ref={nextButtonRef}
            >
              Next
            </Button>
          </>
        )}
      </div>
      <div className="flex flex-row flex-wrap w-[400px] justify-end">
        {company?.companyId && (
          <>
            {GuideMe}
            <Button
              color="light"
              onClick={togglePreview}
              endIcon={
                <div className="bg-dark rounded-full h-5S w-5 flex items-center justify-center text-[0.6rem] text-white">
                  {docCount || 0}
                </div>
              }
            >
              {!showPreview ? 'Show Scans' : 'Hide Scans'}
            </Button>
          </>
        )}
      </div>
    </nav>
  );
};

export default StepNavBar;
